import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getOrdenEnd(data) {
  try {
    const response = await axios.get(
      "/ProcesosP/RelacionLineaCreditoProceso/GetOrderEnd?lineaCredito=" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getRelacionLineaCreditoProceso(data) {
  try {
    const response = await axios.post("/ProcesosP/RelacionLineaCreditoProceso/Get", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function upsertLineaCreditoProceso(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/RelacionLineaCreditoProceso/Post",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
